import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/Login';
import DashboardLayout from './layouts/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Inbox from './pages/Inbox';
import WhatsAppConnection from './pages/WhatsAppConnection';
import DataExtraction from './pages/DataExtraction';
import RecentMessages from './components/RecentMessages';
import UserSettings from './pages/UserSettings';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import AITesting from './pages/AITesting';
import SignUp from './components/SignUp';
import LoginSuccess from './pages/LoginSuccess';
import MagicRedirect from './pages/MagicRedirect.jsx'; // <-- NEW
import { ToastProvider } from './context/ToastContext';

const App = () => {
  return (
    <Router>
      <ToastProvider>
        <AuthProvider>
          <main className="flex-1 overflow-y-auto">
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<Landing />} />
              <Route path="/app/login" element={<Login />} />
              <Route path="/app/signup" element={<SignUp />} />
              <Route path="/app/login/success" element={<LoginSuccess />} />

              {/* Magic redirect (for login via #/magic?...) */}
              <Route path="/magic" element={<MagicRedirect />} />

              {/* Protected Dashboard routes */}
              <Route
                path="/app"
                element={
                  <ProtectedRoute>
                    <DashboardLayout />
                  </ProtectedRoute>
                }
              >
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="inbox" element={<Inbox />} />
                <Route path="whatsapp" element={<WhatsAppConnection />} />
                <Route path="extraction" element={<DataExtraction />} />
                <Route path="messages" element={<RecentMessages />} />
                <Route path="settings" element={<UserSettings />} />
                <Route path="ai" element={<AITesting />} />
              </Route>
            </Routes>
          </main>
        </AuthProvider>
      </ToastProvider>
    </Router>
  );
};

export default App;